import { Component, h, Prop, State } from '@stencil/core';
import Helmet from '@stencil/helmet';
import get from 'lodash/get'
import { SectionList } from '../../functional';
import { getNews, getEvents, getVideos } from '../../shared/api'

@Component({
    tag: 'vw-list'
})
export class VwList {

    @Prop() slug: string;
    @Prop() searchParams: any;
    @Prop() title: string;
    @Prop() description: string;
    @Prop() pagesize: number = 5;
    @Prop() filterOptions: any;
    @Prop() page?: number = 1;
    @State() filters: Array<number> = [];
    @State() content: any = {};
    @State() meta: any;
    @State() data: any = [];


    async getData() {
        switch (this.slug) {
            case 'news': return await getNews(this.page, this.filters, this.pagesize,null, true);
            case 'events': return await getEvents(this.page, this.filters, this.pagesize, true)
            case 'videos': return await getVideos(this.page, this.filters, this.pagesize, null, true)
        }
    }


    async componentWillRender() {
        this.filters = this.searchParams.get('filters')?.split(',');
        const { data, status } = await this.getData()
        if (status !== 200) return;
        this.content.Title = this.title;
        this.content.Description = this.description;
        this.data = get(data, 'data') || [];
        this.meta = get(data, 'meta');
    }
    
    componentDidRender() {
        window.scrollTo(0, 0);
    }

    render() {

        if (!this.content) return (
            <div style={{ 'min-height': 'calc(100vh - 176px)' }} class="uk-position-relative">
                <div class="uk-margin-large uk-text-center">
                    <h1 class="uk-heading">404: Not Found</h1>
                </div>
            </div>
        )

        return [
            <Helmet>
                <title>{`${this.title} | Dennis Mowers`}</title>
                <meta name="description" content={this.description || `Latest ${this.title} from Dennis Mowers.`} />
            </Helmet>,
            <div style={{'min-height':'calc(100vh - 176px)'}} class="uk-position-relative">
                <div class="uk-container uk-container-large">
                    <div style={{ 'border-bottom': '1px solid #f0f0f0' }} />
                </div>
                <div>{<SectionList searchParams={this.searchParams} content={this.content} data={this.data} meta={this.meta} filters={this.filterOptions} slug={this.slug}></SectionList>}
                </div>
            </div>
        ];
    }
}
